module.exports = __webpack_public_path__ + "static/img/vaughan3.7972f82.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cities/vaughan3.jpg
// module id = 6
// module chunks = 9